import { useMemo } from "react";
import {
  IAttemptListItemResponseForWorkOrder,
  ICalendarWorkTemplateBase,
} from "@miplatform/types";
import { TabGroupItem } from "./CalendarVerticalTabs";

export enum SchedulerViewType {
  Assignment = "assignment",
  Scheduler = "scheduler",
}

const baseTabGroups = {
  Unassigned: {
    label: "Unassigned Work Orders",
    view: SchedulerViewType.Assignment,
    badgeTone: "unassigned" as const,
  },
  NotReady: {
    label: "Not Ready Work Orders",
    view: SchedulerViewType.Assignment,
    badgeTone: "notReady" as const,
  },
  Assigned: {
    label: "Assigned Work Orders",
    view: SchedulerViewType.Scheduler,
    badgeTone: "assigned" as const,
  },
} as const;

export type TabGroupKey = keyof typeof baseTabGroups;

export const DEFAULT_GROUP: TabGroupKey = "Unassigned";

type SchedulerTabGroups = Record<
  TabGroupKey,
  (typeof baseTabGroups)[TabGroupKey] & { items: TabGroupItem[] }
>;

export function useNHCPrioritySchedulerTabs(
  workTemplateBases: ICalendarWorkTemplateBase[],
  events: IAttemptListItemResponseForWorkOrder[]
): SchedulerTabGroups {
  return useMemo(() => {
    return Object.fromEntries(
      (Object.keys(baseTabGroups) as TabGroupKey[]).map((groupKey) => [
        groupKey,
        {
          ...baseTabGroups[groupKey],
          items: workTemplateBases.map((template) => ({
            label: template.name,
            value: template.id,
            // TODO: ABK this logic will change once we have solidified groups for work orders
            count:
              groupKey === "Unassigned" || groupKey === "NotReady"
                ? events.filter(
                    (event) =>
                      !event.assignedUserId &&
                      event.workOrderTemplateId === template.id
                  ).length
                : events.filter(
                    (event) =>
                      event.assignedUserId &&
                      event.workOrderTemplateId === template.id
                  ).length,
          })),
        },
      ])
    ) as SchedulerTabGroups;
  }, [workTemplateBases]);
}
